import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary" style={{padding: '2rem', textAlign: 'center'}}>
          <h2>Something went wrong</h2>
          <p>Please refresh the page or check your connection.</p>
          <button onClick={() => window.location.reload()}>Reload Page</button>
          <details style={{marginTop: '1rem', textAlign: 'left'}}>
            <summary>Error details (click to expand)</summary>
            <pre>{this.state.error?.message || 'Unknown error'}</pre>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

